// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Box, Paper, Typography, Button, Grid, TextField, Alert, Divider, CircularProgress } from '@mui/material';
import { Box, Paper, Typography, Button } from '@mui/material';

import TelusLogo from '../components/TelusLogo';

export default function LoginPage() {
    // const navigate = useNavigate();
    // const [username, setUsername] = useState('');
    // const [password, setPassword] = useState('');
    // const [error, setError] = useState('');
    // const [isLoading, setIsLoading] = useState(false);

    // **UPDATED:** The submit handler is now async
    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    //     setError('');
    //     setIsLoading(true);

    //     const userRole = await onLogin(username, password);

    //     setIsLoading(false);

    //     if (userRole === 'admin') {
    //         navigate('/admin-page');
    //     } else if (userRole === 'user') {
    //         navigate('/');
    //     } else {
    //         setError('Invalid username or password.');
    //     }
    // };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
            <Paper elevation={3} sx={{ padding: 4, maxWidth: 400, width: '100%', borderRadius: 3 }}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <TelusLogo />
                    <Typography variant="h5" component="h1" gutterBottom sx={{ mt: 2, fontWeight: 'bold' }}>Copilot Login</Typography>
                </Box>
                
                <Button fullWidth variant="outlined" href="/api/auth/login" sx={{ mb: 2, py: 1.5, textTransform: 'none' }}>
                    Login with Microsoft
                </Button>
                {/* <Divider sx={{ my: 2 }}>OR</Divider>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField required fullWidth label="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField required fullWidth name="password" label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </Grid>
                    </Grid>
                    <Button type="submit" fullWidth variant="contained" disabled={isLoading} sx={{ mt: 3, mb: 2, py: 1.5 }}>
                        {isLoading ? <CircularProgress size={24} /> : 'Sign In with Credentials'}
                    </Button>
                </form> */}
            </Paper>
        </Box>
    );
}

